
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

const dtUpdate         = require ('./inventory-dt-update')
const timeDate         = require ('../../../../../js-handler/time-date')
const dialogInventory  = require ('./inventory-dialog')
const inventorySnack   = require('./inventory-snack')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const dialog           = require ('../../../../../components/dialog/dialog')
const inventoryDt      = require('./inventory-dt')





export const tableDetail = {
    entity: 'inventory',//name table on the db
    dest: 'inventory',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"inventory", "elem":"dt", "id":"inventory-page", "act":"snackAction"} ],
                                
                                 "clickRight": [{"dest":"inventory", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"inventory", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["item.name","item.brand","item_unit.name"],
        mainFilterValues : ["", "", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}



/****************ELEMENTS*****************/



//each element could organize their data diferent
export function organizeRow(data){ 
    
    //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: ''},
                                                { label:'', span: '' }, 
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' }] })
        return newData
    }

    data.forEach((elem)=>{


       // const  shelflifestyle  = dtUpdate.getshelflifestyle(elem)  


        newData.push(
            {   id: elem.id,  
                trDetail:  `data-item = '{"item_name":"${elem.item_name}", "item_unit_id":"${elem.item_unit_id}", "item_unit_name":"${elem.item_unit_name}"}'`, 
                colum: [  { label: elem.item_name, span: elem.brand,
                                            style:{ 
                                                tdClass:'tdWithAvatar',  
                                                avatar:elem.avatar,
                                                avatarColor: '', 
                                                avatarColorLetter: '', 
                                                avatarLetter: '' 
                                                
                                            } }, 
                                         { label: elem.available, span: elem.item_unit_name},
                                         { label: elem.avg_purchase_price_dt, span: elem.last_purchase_price},
                                         { label: elem.avg_selling_price_dt, span: elem.last_sale_price} ]     
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/


//show dialog
export function dialogUpdateSellingPrice(detail) {

  let dbid         = detail.dbid;
  let item_name    = detail.item_name;
  let item_unit_id = detail.item_unit_id;
  let item_unit_name = detail.item_unit_name;
  dialogInventory.start({ act: "show", dest: 'inventory', id: "dialogUpdateSellingPrice", entity: 'inventory',  dbid: dbid, 
                          item_name: item_name, item_unit_id: item_unit_id, item_unit_name: item_unit_name });

}

//show dialog
export function confirmUpdateSellingPrice(detail) {
    let input_sellingPrice = document.querySelector('#inputUpdateSellingPrice');
    let input_value        = (input_sellingPrice.value   == "" || parseFloat(input_sellingPrice.value)   == NaN || 
                             parseFloat(input_sellingPrice.value)   == 0) ? 0 : parseFloat(input_sellingPrice.value);

    if (input_value < 1) {
        inventorySnack.start({ act: 'show', id: 'invalidValue' });
        textfieldHandler.error(input_sellingPrice.closest(".textfield"));
        return;
    }

    dialog.start({act: "hide"})

    setTimeout(() => {
        let dbid = detail.dbid;
        let item_unit_id = detail.item_unit_id;
        dialogInventory.start({ act: "show", dest: 'inventory', id: "confirmUpdateSellingPrice", entity: 'inventory',  dbid: dbid, 
                                item_unit_id: item_unit_id ,newSellingPrice: input_value});
    }, 450);
  
}
  

// funcion para actualizar el selling price del item seleccionado en los purchase que este incluido y que tengan inventario
export function updateSellingPrice(detail) {

    let dbid            = detail.dbid;
    let newSellingPrice = detail.newSellingPrice;
    let item_unit_id    = detail.item_unit_id;

    if (dbid == undefined || dbid == "" || dbid == null) {
        return;
    }
    if (newSellingPrice == undefined || newSellingPrice == "" || newSellingPrice == null) {
        return;
    }

    const formData = new FormData();
    formData.append('item_id', dbid);
    formData.append('item_unit_id', item_unit_id);
    formData.append('newSellingPrice', newSellingPrice);

    const controller = new AbortController();
    const timeout = setTimeout(() => { controller.abort() }, 30000);

    let options = {
        method: 'POST',
        body: formData,
        signal: controller.signal,
        credentials: 'same-origin'
    };

    fetch(`./server/php/sql/updatePurchaseItemSellingPrice.php`, options)
        .then(result => result.json())
        .then(result => {
            if (result.error.val =="error") {
                inventorySnack.start({ act: 'show', id: 'ErrorUpdate' });
            }else{
                inventorySnack.start({ act: 'show', id: 'SuccessUpdate' });
                inventoryDt.start({"dest":"inventory", "elem":"dt", "act":"select", "entity":"inventory"})
            }
        })
        .catch(error => {
            inventorySnack.start({ act: 'show', id: 'ErrorUpdate' });
        });
}


